import fetch from "../fetch";

export default ({ saleId }) => fetch({ path: `/re/sales/${saleId}/props` });
